/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Starting_ToastInputs */

const en_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting image export...`)
};

const fr_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage de l'exportation d'images...`)
};

const de_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildexport wird gestartet...`)
};

const it_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio dell'esportazione dell'immagine...`)
};

const ru_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало экспорта изображения...`)
};

const es_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando exportación de imagen...`)
};

const zh_cn2_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始导出图像...`)
};

const ja_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像のエクスポートを開始しています...`)
};

const hi_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इमेज एक्सपोर्ट शुरू हो रहा है...`)
};

const pt_pt2_image_export_starting_toast = /** @type {(inputs: Image_Export_Starting_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando a exportação da imagem...`)
};

/**
* | output |
* | --- |
* | "Starting image export..." |
*
* @param {Image_Export_Starting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_starting_toast = /** @type {((inputs?: Image_Export_Starting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Starting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_starting_toast(inputs)
	if (locale === "de") return de_image_export_starting_toast(inputs)
	if (locale === "it") return it_image_export_starting_toast(inputs)
	if (locale === "ru") return ru_image_export_starting_toast(inputs)
	if (locale === "es") return es_image_export_starting_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_starting_toast(inputs)
	if (locale === "ja") return ja_image_export_starting_toast(inputs)
	if (locale === "hi") return hi_image_export_starting_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_starting_toast(inputs)
	return en_image_export_starting_toast(inputs)
});